import { Link } from "react-router-dom";
import ComicCard from "@/components/base/ComicCard";
import { mangaList } from "@/mocks/comics";

export default function LatestSection() {
  const latest = [...mangaList]
    .sort((a, b) => (a.updateDate < b.updateDate ? 1 : -1))
    .slice(0, 8);

  return (
    <section className="container-site py-12 md:py-16" aria-labelledby="latest-title">
      <div className="flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-end">
        <div>
          <span className="chip-tag">
            <i className="ri-flashlight-fill text-xs" aria-hidden="true" />
            今日更新
          </span>
          <h2 id="latest-title" className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            最新更新
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            连载作品每日更新，第一时间追更不等待。
          </p>
        </div>
        <Link to="/category/all" className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 cursor-pointer">
          更多更新<i className="ri-arrow-right-line" aria-hidden="true" />
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 md:gap-5">
        {latest.map((comic) => (
          <ComicCard key={comic.slug} comic={comic} />
        ))}
      </div>
    </section>
  );
}